import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

const RadioButtonComponent = ({
  name,
  text,
  value,
  change,
  blur,
  touched,
  error,
  colum,
  row,
  radioText1,
  radioText2,
  radioValue1,
  radioValue2,
  required,
}) => {
  const gridColumn = colum ? colum : undefined;
  const gridRow = row ? row : undefined;
  return (
    <FormControl
      variant="filled"
      fullWidth
      error={!!touched && !!error}
      sx={{ gridColumn: gridColumn, gridRow: gridRow }}
    >
      <FormLabel required={required}>{text}</FormLabel>
      <RadioGroup
        name={name}
        value={value === undefined || value === null ? "" : String(value)}
        onChange={change}
        onBlur={blur}
        row
      >
        <FormControlLabel
          value={String(radioValue1)}
          control={<Radio checked={String(value) === String(radioValue1)} />}
          label={radioText1}
        />
        <FormControlLabel
          value={String(radioValue2)}
          control={<Radio checked={String(value) === String(radioValue2)} />}
          label={radioText2}
        />
      </RadioGroup>
      {!!touched && !!error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default RadioButtonComponent;
